// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  home: path(ROOTS_DASHBOARD, '/home'),
  resetPassword:path(ROOTS_DASHBOARD, '/resetPassword'),
  deviceManage:{
    root: path(ROOTS_DASHBOARD, '/deviceManage'),
    list: path(ROOTS_DASHBOARD, '/deviceManage/list'),
    add: path(ROOTS_DASHBOARD, '/deviceManage/add'),
    deviceModelList: path(ROOTS_DASHBOARD, '/deviceManage/deviceModelList'),
    deviceTypeList: path(ROOTS_DASHBOARD, '/deviceManage/deviceTypeList'),
  },
  feedbackManage:{
    root: path(ROOTS_DASHBOARD, '/feedback'),
    list: path(ROOTS_DASHBOARD, '/feedback/list'),
    detail: path(ROOTS_DASHBOARD, '/feedback/detail'),
  },
  otaManage:{
    root: path(ROOTS_DASHBOARD, '/otaManage'),
    list: path(ROOTS_DASHBOARD, '/otaManage/list'),
    upload: path(ROOTS_DASHBOARD, '/otaManage/upload'),
    detail: path(ROOTS_DASHBOARD, '/otaManage/detail'),
  },
  appUserManage:{
    root: path(ROOTS_DASHBOARD, '/appUserManage'),
    list: path(ROOTS_DASHBOARD, '/appUserManage/list'),
    add: path(ROOTS_DASHBOARD, '/appUserManage/add'),
  },
  userManage:{
    root: path(ROOTS_DASHBOARD, '/userManage'),
    list: path(ROOTS_DASHBOARD, '/userManage/list'),
    add: path(ROOTS_DASHBOARD, '/userManage/add'),
  },
  tankType:{
    root: path(ROOTS_DASHBOARD, '/tankType'),
    list: path(ROOTS_DASHBOARD, '/tankType/list'),
    secondList: path(ROOTS_DASHBOARD, '/tankType/secondList'),
    addSecond: path(ROOTS_DASHBOARD, '/tankType/addSecond'),
    secondDetail: path(ROOTS_DASHBOARD, '/tankType/secondDetail'),
  },
  tankManage:{
    root: path(ROOTS_DASHBOARD, '/tankManage'),
    list: path(ROOTS_DASHBOARD, '/tankManage/list'),
  },
  automationMigration:{
    root: path(ROOTS_DASHBOARD, '/automationMigration'),
    list: path(ROOTS_DASHBOARD, '/automationMigration/list'),
  },
};
